import * as fn from './utils'
import Blog1 from './images/depressao.png'
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useState, useEffect} from 'react'
import SendIcon from '@mui/icons-material/Send';
import AddIcon from '@mui/icons-material/Add';
import {db, storage} from './firebase'
import {addDoc, collection, doc, getDocs, updateDoc} from 'firebase/firestore'
import {getDownloadURL, ref, uploadBytes} from 'firebase/storage'
import {FormProvider} from './Context';
import useForm from './useForm';
import { Blog } from './Blog';

function Form(props:any){

    const styled:any = ()=>{
        const new_style={...props.styles, ...{
            border:'0px solid',
            backgroundColor:'transparent'
        }}
        return(new_style)
    }

    const [focus, setFocus] = useState(false)
    const [text, setText] = useState(props.defVal)
    const {setForm, form}:any = useForm()

    useEffect(()=>{
        if(focus){
            document.getElementById(props.id)?.focus()
            document.getElementById(props.id)?.addEventListener('focusout', ()=>{
                setFocus(false)
            })
        } else {
            if(!text){
                setText(props.defVal)
            }
        }
    },[focus])

    useEffect(()=>{
        if(form[props.id]!=undefined){
            let old_form = {...form}
            old_form[props.id] = text
            setForm(old_form)
        }
    },[text])

    return(
        <div>
            {focus&&(
                <div>
                    {props.id=='titulo'&&(
                        <input id={props.id} type='text' onChange={(e)=>{setText(e.target.value)}} value={text} style={{...styled(), width:'340px'}}/>
                    )||(
                        <textarea id={props.id} onChange={(e)=>{setText(e.target.value)}} value={text} style={{...styled(),...{width:props.mobile?'90%':'340px', height:'200px'}}}/>
                    )}
                </div>
            )}
            {!focus&&(<span onClick={()=>{setFocus(true)}}>{text}</span>)}
        </div>
    )
}

// export function ImagePost(props:any){

//     const [image, setImage] = useState('')

//     async function getImage(){
//         const new_img = await getDownloadURL(ref(storage,'posts/'+props.imageURL))
//         setImage(new_img)
//     }
//     useEffect(()=>{
//         getImage()
//     },[])

//     return(
//         <div style={{backgroundImage:`url(`+image+`)`, width:'300px', height:'300px', backgroundSize:'cover'}}/>
//     )
// }

function NewPost(props:any){

    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = today.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    const {setForm, form}:any = useForm()
    const {page, setPage}:any = useForm()


    const [uploadedImg, setUploadedImg] = useState<any>('')
    const [blobURL, setBlobURL] = useState('')

    async function sendPost(){

        const extension = uploadedImg.name.split('.').pop()
        const object = {
            title: form.titulo,
            text: form.texto,
            date: formattedDate,
            image: extension
        }

        await addDoc(collection(db, 'blog'),object)
        .then(async(doc)=>{
            if(uploadedImg){
                await uploadBytes(ref(storage, `posts/${doc.id}.${extension}`),uploadedImg)
                .then(()=>{
                    setPage(0)
                })
            } else {
                setPage(0)
            }
        })
    }

    function handleFileClick(){
        document.getElementById('imageupload')?.click()
    }

    useEffect(()=>{
        if(uploadedImg){
            const blobsURL = URL.createObjectURL(uploadedImg)
            setBlobURL(blobsURL)
        }
    },[uploadedImg])

    useEffect(()=>{
        if(Object.keys(form).length==0){
            const defVal = {titulo:'Título', texto:'Texto'}
            setForm(defVal)
        }
    },[])

    return(
        <div style={{backgroundColor:fn.Colors.pastelLight, display:'flex', width:props.mobile?'90%':'60%', justifyContent:'center', alignItems:'center', marginTop:'20px', borderRadius:'10px', padding:'20px 0', flexDirection:props.mobile&&('column')}}>
                            {props.mobile&&(
                                <div className='form' style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px'}}>
                                    <Form id='titulo' defVal ='Título' styles={{fontFamily:fn.Fonts.subtitle, fontSize:'35px', fontWeight:'600'}} mobile={props.mobile}/>
                                </div>
                            )}
                            {props.mobile&&(
                                <div style={{fontWeight:'600', fontSize:'12px', color:fn.Colors.foreground}}>
                                    escrito por Stephanie Faria em {formattedDate}
                                </div>
                            )}
                        <div style={{height:props.mobile?'':'50%',boxSizing:'border-box', display:'flex', justifyContent:'center',alignItems:'center', margin:props.mobile?'10px 0':''}}>
                            <div style={{display:'flex',justifyContent:'left', alignItems:'center'}}>
                                {!uploadedImg&&(
                                <div style={{width:'300px', height:'300px', backgroundSize:'cover', border:'1px dashed '+fn.Colors.foreground, borderRadius:'10px', display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer'}} onClick={()=>{handleFileClick()}}>
                                    <AddIcon style={{color:fn.Colors.foreground, scale:'10', opacity:'0.5'}}/>
                                </div>
                                )}
                                {uploadedImg&&(
                                    <div style={{backgroundImage:'url('+blobURL+')',width:'300px', height:'300px', backgroundSize:'cover', display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer'}} onClick={()=>{handleFileClick()}}/>
                                    // <img id='display_image' style={{width:'300px', height:'300px'}}/>
                                )}
                            </div>
                        </div>
                        <div style={{width:props.mobile?'100%':'50%', display:'flex',justifyContent:'left', flexDirection:'column',paddingLeft:'40px', boxSizing:'border-box'}}>
                            {!props.mobile&&(
                            <div className='form' style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px'}}>
                                <Form id='titulo' defVal ='Título' styles={{fontFamily:fn.Fonts.subtitle, fontSize:'35px', fontWeight:'600'}} mobile={props.mobile}/>
                            </div>
                            )}
                            {!props.mobile&&(
                            <div style={{fontWeight:'600', fontSize:'12px', color:fn.Colors.foreground}}>
                                escrito por Stephanie Faria em {formattedDate}
                            </div>
                            )}
                            <div className='form' style={{margin:'10px 0', whiteSpace:'pre-wrap'}}>
                                <Form id='texto' defVal='Texto' styles={{fontFamily:`-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif`, fontSize:'14px'}} mobile={props.mobile}/>
                                <input id='imageupload' type='file' style={{display:'none'}} onChange={(e)=>{setUploadedImg(e.target?.files![0])}}/>
                            </div>
                            <div style={{display:'flex', justifyContent:'right', width:props.mobile&&( '90%')}}>
                                <SendIcon style={{scale:'1.3', cursor:'pointer'}} onClick={()=>{sendPost()}}/>
                            </div>
                        </div>
        </div>
    )
}

function EditPost(props:any){


    const {postData, setPostData}:any = useForm()
    const {page, setPage}:any = useForm()

    const formattedDate = postData.date
    const {setForm, form}:any = useForm()

    const [uploadedImg, setUploadedImg] = useState<any>('')
    const [blobURL, setBlobURL] = useState('')

    async function getImage(){
        const new_img = await getDownloadURL(ref(storage,`posts/${postData.doc_id}.${postData.image.split('.').pop()}`))
        setBlobURL(new_img)
    }

    async function savePost(){

        const extension = uploadedImg.name.split('.').pop()

        const object = {
            title: form.titulo,
            text: form.texto,
            date: formattedDate,
            image: extension
        }

        await updateDoc(doc(db, 'blog', postData.doc_id),object)
        .then(async()=>{
            if(uploadedImg){
                await uploadBytes(ref(storage, `posts/${postData.doc_id}.${extension}`),uploadedImg)
                .then(()=>{
                    setPage(0)
                })
            } else {
                setPage(0)
            }
        })
    }

    function handleFileClick(){
        document.getElementById('imageupload')?.click()
    }

    useEffect(()=>{
        if(uploadedImg){
            const blobsURL = URL.createObjectURL(uploadedImg)
            setBlobURL(blobsURL)
        }
    },[uploadedImg])

    useEffect(()=>{
        if(Object.keys(form).length==0){
            const defVal = {titulo:postData.title, texto:postData.text}
            setForm(defVal)
        }
        if(!blobURL){
            getImage()
        }
    },[])

    return(
        <div style={{backgroundColor:fn.Colors.pastelLight, display:'flex', width:props.mobile?'90%':'60%', justifyContent:'center', alignItems:'center', marginTop:'20px', borderRadius:'10px', padding:'20px 0', flexDirection:props.mobile&&('column')}}>
                        {props.mobile&&(
                            <div className='form' style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px', width:'90%'}}>
                                <Form id='titulo' defVal={postData.title} styles={{fontFamily:fn.Fonts.subtitle, fontSize:'35px', fontWeight:'600'}}/>
                            </div>
                        )}
                        {props.mobile&&(
                            <div style={{fontWeight:'600', fontSize:'12px', color:fn.Colors.foreground}}>
                                escrito por Stephanie Faria em {postData.date}
                            </div>
                        )}
                        <div style={{height:props.mobile?'':'50%',boxSizing:'border-box', display:'flex', justifyContent:'center',alignItems:'center', margin:props.mobile?'10px 0':''}}>
                            <div style={{display:'flex',justifyContent:'left', alignItems:'center'}}>
                                    <div style={{backgroundImage:'url('+blobURL+')',width:'300px', height:'300px', backgroundSize:'cover', display:'flex', justifyContent:'center', alignItems:'center', cursor:'pointer'}} onClick={()=>{handleFileClick()}}/>
                            </div>
                        </div>
                        <div style={{width:props.mobile?'100%':'50%', display:'flex',justifyContent:'left', flexDirection:'column',paddingLeft:'40px', boxSizing:'border-box'}}>
                            {!props.mobile&&(
                            <div className='form' style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px'}}>
                                <Form id='titulo' defVal={postData.title} styles={{fontFamily:fn.Fonts.subtitle, fontSize:'35px', fontWeight:'600'}}/>
                            </div>
                            )}
                            {!props.mobile&&(
                            <div style={{fontWeight:'600', fontSize:'12px', color:fn.Colors.foreground}}>
                                escrito por Stephanie Faria em {postData.date}
                            </div>
                            )}
                            <div className='form' style={{margin:'10px 0', whiteSpace:'pre-wrap', width:props.mobile&&('90%')}}>
                                <Form id='texto' defVal={postData.text} styles={{fontFamily:`-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif`, fontSize:'14px'}}/>
                                <input id='imageupload' type='file' style={{display:'none'}} onChange={(e)=>{setUploadedImg(e.target?.files![0])}}/>
                            </div>
                            <div style={{display:'flex', justifyContent:'right', width:props.mobile&&('90%')}}>
                                <SendIcon style={{scale:'1.3', cursor:'pointer'}} onClick={()=>{savePost()}}/>
                            </div>
                        </div>
        </div>
    )
}

export function Painel(props:any){

    const {page, setPage}:any = useForm()
    const {postData, setPostData}:any = useForm()
    const [auth, setAuth] = useState(false)

    function goLogin(){
        if((document.getElementById('pass') as HTMLInputElement).value=='Tephy1'){
            setAuth(true)
        }
    }

    useEffect(()=>{
        if(Object.keys(postData).length>0){
            setPage(2)
        }
    },[postData])

    return(
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            <div style={{display:'flex', justifyContent:'center', marginTop:'50px', width:'100%'}}>
                {!auth&&(
                    <div>
                        <input id='pass' type='password'/>
                        <div><span style={{cursor:'pointer', fontWeight:'600', fontSize:'12px'}} onClick={()=>{goLogin()}}>Entrar</span></div>
                    </div>
                )||(<div style={{width:'100%', display:'flex', flexDirection:'column',alignItems:'center'}}>
                <div style={{fontWeight:'600', fontFamily:fn.Fonts.subtitle, fontSize:props.mobile?'30px':'35px'}}>
                    Blog
                </div>
                {page==0&&(
                        <div style={{backgroundColor:fn.Colors.pastelLight, display:'flex', width:props.mobile?'90%':'60%', justifyContent:'center', alignItems:'center', marginTop:'50px', borderRadius:'10px', padding:'20px 0', cursor:'pointer'}} onClick={()=>{setPage(1)}}>
                            <div style={{transform:'translateY(2px)', marginRight:'5px'}}>
                                <AddCircleOutlineIcon/>
                            </div>
                            <div>
                                Nova Postagem
                            </div>
                        </div>
                )}
                {page==0&&(<Blog access={1} mobile={props.mobile}/>)}
                {page==1&&(<NewPost mobile={props.mobile}/>)}
                {page==2&&(<EditPost mobile={props.mobile}/>)}
                </div>
                )}
            </div>
        </div>
    )
}